module.exports = __webpack_public_path__ + "img/home-page.4a9c899d.png";